var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-154 -731) translate(121 720) translate(32 11) translate(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.84.532c-1.462 0-2.787.553-3.745 1.45C1.149 2.865.561 4.087.561 5.438c0 1.18.823 2.755 1.81 4.19 1.298 1.888 2.933 3.716 3.47 3.716.603 0 2.6-2.271 3.948-4.45.755-1.22 1.33-2.475 1.33-3.456 0-1.351-.588-2.573-1.534-3.458C8.627 1.085 7.302.532 5.84.532z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 2
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationField);
export default __webpack_public_path__ + "static/media/location-field.66a8a064.svg";
export { ForwardRef as ReactComponent };